<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col cols="6" class="py-0">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn color="tertiary" @click="showProjectDialog" class="mr-3">Project toevoegen</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="items"
            :options.sync="options"
            :items-per-page-items="itemsPerPageItems"
            :server-items-length="totalItems"
            @click:row="toProject"
          >

            <template v-slot:top>
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-col cols="5">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-folder-search"
                    label="Zoeken"
                    single-line
                    hide-details
                    class="ml-3"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <template v-slot:item.desired_delivery_date="{ value }">
              {{ formatDate(value) }}
            </template>

            <template v-slot:item.status="{ value }">
              <v-icon :color="value == 20 ? 'green' : 'grey'">mdi-circle-medium</v-icon>
            </template>

            <template v-slot:item.action="{ item }">
              <v-icon
                v-if="item.status == 10"
                small
                class=""
                @click.stop="$refs.confirmDelete.showDialog(item.id)"
              >mdi-trash-can-outline</v-icon>
            </template>

            <template v-slot:no-data>
              <span>Geen data beschikbaar.</span>
            </template>

          </v-data-table>

          <ProjectDialog ref="projectDialog" @update="itemCreated" />
          <ConfirmDialog ref="confirmDelete" title="Verwijderen" @confirm="deleteItem"></ConfirmDialog>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ProjectDialog from '@/components/ProjectDialog'
import moment from 'moment'
import ConfirmDialog from '@/components/ConfirmDialog'
import _ from 'lodash'

export default {
  components: {
    ProjectDialog,
    ConfirmDialog,
  },
  data: () => ({

    headers: [
      { text: 'Projectnummer', value: 'project_number', align: 'left', sortable: false, width: '20%' },
      { text: 'Bonnummer', value: 'reference_number', align: 'left', sortable: false, width: '20%' },
      { text: 'Projectmanager', value: 'user.full_name', align: 'left', sortable: false, width: '20%' },
      { text: 'Verwachte leverdatum', value: 'desired_delivery_date', align: 'left', sortable: false, width: '20%'},
      { text: 'Status', value: 'status', align: 'center', sortable: false, width: '10%' },
      { text: 'Acties', value: 'action', align: 'center', sortable: false, width: '10%' },
    ],

    items: [], // projects
    totalItems: 0,
    loading: true,
    options: { itemsPerPage: 10 },
    search: null,

    itemsPerPageItems: [5, 10, 25, 50],
  }),
  watch: {
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    search() {
      this.fetchItems()
    },
  },
  created() {
    this.restoreFilters()

    this.breadcrumbs = [
      {
        text: 'Projecten',
        disabled: true,
      },
    ]
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format('DD-MM-YYYY') : null
    },
    showProjectDialog() {
      this.$refs.projectDialog.showDialog()
    },
    toProject(item) {
      this.$router.push({
        name: 'project',
        params: {
          projectId: item.id,
        },
      })
    },
    itemCreated(item) {
      this.toProject(item)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/projects', this.options, {
        params: {
          expand: 'user',
          filter: {
            query: this.search,
          },
          sort: '-created_at',
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_projects', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_projects')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
    deleteItem(itemId) {
      ApiService.delete(`/projects/${itemId}`).finally(() => {
        this.fetchItems()
      })
    },
  }

}
</script>

<style scoped>

::v-deep .v-data-table table tbody tr:not(.v-data-table__empty-wrapper):hover {
  cursor: pointer;
}


</style>